module.exports = __webpack_public_path__ + "5483940915fbab8362a8c49c438d211b.png";